import { connect } from 'react-redux'
import PricingTable from './PricingTable'
import { replace } from 'react-router-redux'

const mapStateToProps = () => ({})

const dispatchToProps = {
  replace,
}

export default connect(mapStateToProps, dispatchToProps)(PricingTable)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/PricingTable/PricingTable.container.js